import Status from './status';
import BankInfoStep from './BankInfoStep';
import BusinessDetailsStep from './BusinessDetailsStep';
import BusinessDocumentStep from './BusinessDocumentStep';
import BusinessInfoStep from './BusinessInfoStep';
import CompleteOnboardingExplainer from './CompleteOnboardingExplainer';
import ContractStep from './ContractStep';
import ContractPaymentStep from './ContractPaymentStep';
import DeliveryStructureStep from './DeliveryStructureStep';
import DocumentsStep from './DocumentsStep';
import InfoSubmissionStep from './InfoSubmissionStep';
import MobileAppStep from './MobileAppStep';
import OwnerDocumentStep from './OwnerDocumentStep';
import OwnerPersonalInfoStep from './OwnerPersonalInfoStep';
import PaymentInfoStep from './PaymentInfoStep';
import PersonalInfoStep from './PersonalInfoStep';
import PromoCodeStep from './PromoCodeStep';
import ShippingInfoStep from './ShippingInfoStep';
import StoreDetailsStep from './StoreDetailsStep';
import SubscriptionStep from './SubscriptionStep';
import TaxInfoStep from './TaxInfoStep';

export default {
  Status,
  BankInfoStep,
  BusinessDetailsStep,
  BusinessDocumentStep,
  BusinessInfoStep,
  CompleteOnboardingExplainer,
  ContractStep,
  ContractPaymentStep,
  DeliveryStructureStep,
  DocumentsStep,
  InfoSubmissionStep,
  MobileAppStep,
  OwnerDocumentStep,
  OwnerPersonalInfoStep,
  PaymentInfoStep,
  PersonalInfoStep,
  PromoCodeStep,
  ShippingInfoStep,
  StoreDetailsStep,
  SubscriptionStep,
  TaxInfoStep,
};
